var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMp3White(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 45,
    height: 45,
    rx: 2,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2084 11.375C22.6561 11.375 22.2084 11.8227 22.2084 12.375V12.6667V17.8333V24.545C22.2084 25.3159 21.3461 25.8218 20.589 25.6762C20.2725 25.6154 19.9498 25.5841 19.625 25.5833C18.2548 25.5833 16.9406 26.1277 15.9717 27.0966C15.0027 28.0656 14.4584 29.3797 14.4584 30.75C14.4584 32.1203 15.0027 33.4344 15.9717 34.4034C16.9406 35.3723 18.2548 35.9167 19.625 35.9167C20.9953 35.9167 22.3095 35.3723 23.2784 34.4034C24.2474 33.4344 24.7917 32.1203 24.7917 30.75V18.8333C24.7917 18.281 25.2394 17.8333 25.7917 17.8333H31.5417C32.094 17.8333 32.5417 17.3856 32.5417 16.8333V12.375C32.5417 11.8227 32.094 11.375 31.5417 11.375H23.2084Z",
    fill: "#DFC5FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMp3White);
export default __webpack_public_path__ + "static/media/ic_mp3_white.593f2b79698974d89a4316abf6052585.svg";
export { ForwardRef as ReactComponent };